<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
name: "baseBar";
import { ref, onMounted,defineProps } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Object,
    default: () => {},
  },
})
// console.log(props.listData);
const myEcharts = ref(null);

onMounted(() => {
  // let data = [
  //   { value: 287.5, name: "2023年全县生产总值" },
  //   { value: 54.57, name: "第一产业增加值" },
  //   { value: 93.51, name: "第二产业增加值" },
  //   { value: 139.44, name: "第三产业增加值" },
  // ];
  initChart(props.listData);
});

function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);
  console.log(listData)

var barChartList = [
  { value: 4837, name: '一期项目' },
  { value: 17563, name: '二期项目' },
]
  let total = Math.max(...barChartList.map(item => item.value))
  var optionRich = {
    a: {
      // width: 60,
      fontSize: 14,
      color: '#FFF',
      lineHeight: 20,
      // padding: [0, 50, 0, 0]
    },
    c:{
      fontSize: 14,
    }
  }
  barChartList.forEach((ele, i) => {
    optionRich[i] = {
      // width: 20,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 20,
      color: '#FFF',
      align: 'center',
      padding: [0, 0, 0, 10]
    }
  });
  const option= {
    color:["#FFBB26","#019772",],
    grid: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    },
    title: {
      text: '',
      x: 'center'
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b} : {c} ({d}%)'
    },
    legend: {
      show: true,
      // data: ['一期项目', '二期项目'],
      textStyle: {
        color: '#fff',
        rich: optionRich
      },
      formatter: function (name) {
        let index = 0
        let value = 0;
        let rate = 0;
        for (let i = 0; i < barChartList.length; i++) {
          if (barChartList[i].name == name) {
            value = barChartList[i].value ? barChartList[i].value : 0;
            rate = (total / barChartList[i].value).toFixed(0);
            index = i;
          }
        }
        return `{a|${name}}{${index}|${value}}{c|万元}`
      },

    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: '65%',
        center: ['50%', '50%'],
        label: {
          show: true,
          formatter: '{b} {d}%',
          textStyle: {
            color: '#fff',
            fontSize:14
          },
        },
        data: [
          { value: 4837, name: '一期项目' },
          { value: 17563, name: '二期项目' },
        ]
      }
    ]
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option, true);
}
window.addEventListener("resize", () => {
  chartInstance.resize();
});

</script>
<style lang="less"></style>
